<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Array} list of font family names
   */
  export let dropdownItems = []
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  export let activeItem = ""
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  export let customPlaceHolder = "Select Mode of Signing"
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown

  const imageMappings = {
    "Aadhaar ESign": "assets/img/aadhaar.svg",
    "DSC Digital Signing (Dongle)": "assets/img/dscSign.svg",
    ESign: "assets/img/eSign.svg",
  }

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative z-20 w-full" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="relative w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 text-left shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm"
  >
    <div class="flex justify-between text-black dark:text-slate-200">
      <div class="flex items-center gap-3 text-sm">
        {#if activeItem}
          <img src={imageMappings[activeItem]} alt={activeItem} class="aspect-square w-6" />
          {activeItem}
        {:else}
          {customPlaceHolder}
        {/if}
      </div>
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <ul style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute z-10 mt-1 max-h-56 w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-xs ring-opacity-5 focus:outline-none dark:bg-[#2e2e2e] md:text-base" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={(e) => {
          activeItem = item
          showDropdown = false
          dispatch("select", activeItem)
        }}
        class="relative flex cursor-pointer select-none items-center gap-3 rounded-md text-left text-black dark:text-white {activeItem == item ? 'bg-slate-200 font-semibold dark:bg-black' : 'bg-transparent hover:bg-slate-200 dark:hover:bg-black'} py-2 px-3"
      >
        <img src={imageMappings[item]} alt={item} class="aspect-square w-6" />
        {item}
      </li>
    {/each}
  </ul>
</div>
